
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wedding",
      function () {
        return require("private-next-pages/wedding/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wedding"])
      });
    }
  